export default {
  buttons: {
    title1: 'Rajaa',
    title2: 'Sulje',
  },
};
